export default {
    site: {
        title: "Upgates Dokumentace",
        logo: {
            src: {
                light: "/images/logo-light.svg",
                dark: "/images/logo-dark.svg"
            },
            alt: "Upgates Dokumentace",
            width: "130px",
        },
        footer: {
            position: "center",
            /*columns: [
                {
                    title: "Product",
                    position: "start",
                    links: [
                        { label: "Features", href: "/features" },
                        { label: "Pricing", href: "/pricing" },
                        { label: "Documentation", href: "/docs" }
                    ]
                },
                {
                    title: "Resources",
                    position: "center",
                    links: [
                        { label: "Blog", href: "/blog" },
                        { label: "Support", href: "/support" },
                        { label: "GitHub", href: "https://github.com/yourusername" } // Auto-detected as external
                    ]
                }
            ],*/
            copyright: `© 2014 - ${new Date().getFullYear()} EVici webdesign s.r.o.`,
            logo: {
                src: {
                    light: "/images/mascot-main.png",
                    dark: "/images/mascot-main.png"
                },
                alt: "Upgates shops",
                width: "100px"
            }
        },
        /*banner: {
            message: "Welcome to our beta documentation!",
            color: "info", // "note" | "tip" | "info" | "caution" | "danger" or custom
            dismissible: true
        }*/
    },
    metadata: {
        favicon: "/favicon.ico",
        title: "%s | Upgates Dokumentace",
    },
    navigation: [
        {
            type: "category",
            label: "API",
            icon: "file",
            items: [
                {
                    type: "doc",
                    file: "api/intro",
                    label: "Základní informace",
                    icon: "info"
                },
                {
                    type: "doc",
                    file: "api/rate-limiting",
                    label: "Rate limiting",
                    icon: "circle-gauge"
                },
                {
                    type: "doc",
                    file: "api/best-practices",
                    label: "Best practices",
                    icon: "flag"
                },
                {
                    type: "doc",
                    file: "api/changelog",
                    label: "Changelog",
                    icon: "list"
                }
            ]
        },
        {
            type: "link",
            to: "/api-reference",
            label: "API reference",
            icon: "send",
        },
        {
            type: "category",
            label: "Webhooky",
            icon: "webhook",
            items: [
                {
                    type: "doc",
                    file: "webhooks/intro",
                    label: "Základní informace"
                },

                // TODO: nepublikovat, Benefity vyjdou až v další verzi
                // {
                //     type: "doc",
                //     file: "webhooks/benefits",
                //     label: "Benefity"
                // },
                {
                    type: "doc",
                    file: "webhooks/pricelists",
                    label: "Ceníky"
                },
                {
                    type: "doc",
                    file: "webhooks/availabilities",
                    label: "Dostupnosti"
                },
                {
                    type: "doc",
                    file: "webhooks/invoices",
                    label: "Dokumenty"
                },
                {
                    type: "doc",
                    file: "webhooks/shipments",
                    label: "Dopravy"
                },
                {
                    type: "doc",
                    file: "webhooks/languages",
                    label: "Jazyky"
                },
                {
                    type: "doc",
                    file: "webhooks/categories",
                    label: "Kategorie"
                },
                {
                    type: "doc",
                    file: "webhooks/orders",
                    label: "Objednávky"
                },
                {
                    type: "doc",
                    file: "webhooks/payments",
                    label: "Platby"
                },
                {
                    type: "doc",
                    file: "webhooks/products",
                    label: "Produkty"
                },
                // TODO: nepublikovat, Překlady vyjdou až v další verzi
                // {
                //     type: "doc",
                //     file: "webhooks/translations",
                //     label: "Překlady"
                // },
                {
                    type: "doc",
                    file: "webhooks/order-statuses",
                    label: "Stavy objednávky"
                },
                {
                    type: "doc",
                    file: "webhooks/labels",
                    label: "Štítky"
                },
                {
                    type: "doc",
                    file: "webhooks/users",
                    label: "Uživatelé"
                },
                {
                    type: "doc",
                    file: "webhooks/users-roles",
                    label: "Uživatelské role"
                },
                {
                    type: "doc",
                    file: "webhooks/customers",
                    label: "Zákazníci"
                }
            ]
        },

        {
            type: "category",
            label: "Import / Export",
            icon: "arrow-up-down",
            items: [
                {
                    type: "doc",
                    file: "import-export/intro",
                    label: "Základní informace",
                    icon: "info"
                },
                {
                    type: "category",
                    label: "CSV",
                    icon: "file-spreadsheet",
                    items: [
                        {
                            type: "doc",
                            file: "import-export/csv/intro",
                            label: "Základní informace"
                        },
                        {
                            type: "doc",
                            file: "import-export/csv/categories",
                            label: "Kategorie"
                        },
                        {
                            type: "doc",
                            file: "import-export/csv/orders",
                            label: "Objednávky"
                        },
                        {
                            type: "doc",
                            file: "import-export/csv/products",
                            label: "Produkty"
                        },
                        {
                            type: "doc",
                            file: "import-export/csv/redirections",
                            label: "Přesměrování"
                        },
                        {
                            type: "doc",
                            file: "import-export/csv/vouchers",
                            label: "Slevové kupony"
                        },
                        {
                            type: "doc",
                            file: "import-export/csv/customers",
                            label: "Zákazníci"
                        }
                    ]
                },
                {
                    type: "category",
                    label: "XML",
                    icon: "code",
                    items: [
                        {
                            type: "doc",
                            file: "import-export/xml/intro",
                            label: "Základní informace"
                        },
                        {
                            type: "doc",
                            file: "import-export/xml/texts",
                            label: "Články a aktuality"
                        },
                        {
                            type: "doc",
                            file: "import-export/xml/categories",
                            label: "Kategorie"
                        },
                        {
                            type: "doc",
                            file: "import-export/xml/orders",
                            label: "Objednávky"
                        },
                        {
                            type: "doc",
                            file: "import-export/xml/products",
                            label: "Produkty"
                        },
                        {
                            type: "doc",
                            file: "import-export/xml/customers",
                            label: "Zákazníci"
                        }
                    ]
                }
            ]
        },
        {
            type: "category",
            label: "Konverzní kódy",
            icon: "file-braces",
            items: [
                {
                    type: "doc",
                    file: "conversion-codes/intro",
                    label: "Základní informace"
                },
                {
                    type: "doc",
                    file: "conversion-codes/cookies",
                    label: "Cookies"
                },
                {
                    type: "doc",
                    file: "conversion-codes/category",
                    label: "Kategorie"
                },
                {
                    type: "doc",
                    file: "conversion-codes/cart",
                    label: "Košík"
                },
                {
                    type: "doc",
                    file: "conversion-codes/order",
                    label: "Objednávka"
                },
                {
                    type: "doc",
                    file: "conversion-codes/product",
                    label: "Produkt"
                },
                {
                    type: "doc",
                    file: "conversion-codes/site",
                    label: "Stránka"
                },
                {
                    type: "doc",
                    file: "conversion-codes/events",
                    label: "Události"
                },
                {
                    type: "doc",
                    file: "conversion-codes/search",
                    label: "Vyhledávání"
                },
                {
                    type: "doc",
                    file: "conversion-codes/customer",
                    label: "Zákazník"
                }
            ]
        },
        {
            type: "category",
            label: "Doplňky",
            icon: "blocks",
            items: [
                {
                    type: "doc",
                    file: "addons/intro",
                    label: "Základní informace"
                }
            ]
        }
    ],
    redirects: [
        {
            from: "/",
            to: "/api/intro"
        }
    ],
    apis: [
        {
            type: "file",
            input: "./api/upgates.yaml",
            path: "/api-reference",
            options: {
                expandAllTags: false,
                showInfoPage: true,
                disablePlayground: true
            }
        }
    ],
    search: {
        type: "pagefind",
        maxSubResults: 3
    },
    theme: {
        light: {
            "background": "oklch(100% 0 none)",
            "foreground": "oklch(14.7% 0.004 49.3)",
            "card": "oklch(100% 0 none)",
            "cardForeground": "oklch(14.7% 0.004 49.3)",
            "popover": "oklch(100% 0 none)",
            "popoverForeground": "oklch(14.7% 0.004 49.3)",
            "primary": "oklch(70.5% 0.187 47.6)",
            "primaryForeground": "oklch(98.5% 0.001 106)",
            "secondary": "oklch(97% 0.001 106)",
            "secondaryForeground": "oklch(21.6% 0.006 56)",
            "muted": "oklch(97% 0.001 106)",
            "mutedForeground": "oklch(55.3% 0.012 58.1)",
            "accent": "oklch(97% 0.001 106)",
            "accentForeground": "oklch(21.6% 0.006 56)",
            "destructive": "oklch(63.7% 0.208 25.3)",
            "destructiveForeground": "oklch(98.5% 0.001 106)",
            "border": "oklch(92.3% 0.003 48.7)",
            "input": "oklch(92.3% 0.003 48.7)",
            "ring": "oklch(70.5% 0.187 47.6)"
        },
        dark: {
            "background": "oklch(14.7% 0.004 49.3)",
            "foreground": "oklch(98.5% 0.001 106)",
            "card": "oklch(14.7% 0.004 49.3)",
            "cardForeground": "oklch(98.5% 0.001 106)",
            "popover": "oklch(14.7% 0.004 49.3)",
            "popoverForeground": "oklch(98.5% 0.001 106)",
            "primary": "oklch(64.5% 0.194 41.1)",
            "primaryForeground": "oklch(98.5% 0.001 106)",
            "secondary": "oklch(26.9% 0.006 34.3)",
            "secondaryForeground": "oklch(98.5% 0.001 106)",
            "muted": "oklch(26.9% 0.006 34.3)",
            "mutedForeground": "oklch(71.6% 0.009 56.3)",
            "accent": "oklch(26.9% 0.006 34.3)",
            "accentForeground": "oklch(98.5% 0.001 106)",
            "destructive": "oklch(57.7% 0.215 27.3)",
            "destructiveForeground": "oklch(98.5% 0.001 106)",
            "border": "oklch(26.9% 0.006 34.3)",
            "input": "oklch(26.9% 0.006 34.3)",
            "ring": "oklch(64.5% 0.194 41.1)"
        }
    }
};
